interface PinCardParams {
  projectId: string
  cardType: 'task' | 'hypotheses'
  cardId: number
}

const endpoints = {
  getDiscoveries: ({ projectId }: { projectId: string }): string => {
    return `api/v2/users/user-id/projects/${projectId}/discoveries`
  },
  getCharts: ({ projectId }: { projectId: string }): string => {
    return `api/v2/users/user-id/projects/${projectId}/charts`
  },
  pinCard: ({ projectId, cardType, cardId }: PinCardParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/discoveries/cards/${cardType}/${cardId}`
  },
}

export default endpoints
